import { isElement } from 'react-is';
import defaultGetOptionLabel from './default-get-option-label.esm.js';

function defaultGetOptionDisplayLabel() {
  var getOptionLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGetOptionLabel;
  return function (option) {
    return option && !isElement(option) && !Array.isArray(option) ? getOptionLabel(option) : '';
  };
}

export default defaultGetOptionDisplayLabel;
//# sourceMappingURL=default-get-option-display-label.esm.js.map
